module.exports = __webpack_public_path__ + "static/media/iconAbsences.22098178.svg";